module.exports = __webpack_public_path__ + "img/fifth.9665625e.png";